import _ from 'lodash'
import {Attribute} from "@/entity/Attribute";

export class User {
  constructor(props = {}) {
    this.id = props.id
    this.mail = props.mail || ''
    this.familyName = props.familyName || ''
    this.firstName = props.firstName || ''
    this.familyNameKana = props.familyNameKana || ''
    this.firstNameKana = props.firstNameKana || ''

    const attribute = props.attributes
    if (typeof attribute === "string" || attribute instanceof String) {
      this.attributes = _.sortBy(JSON.parse(props.attributes || "[]").map((a) => { return new Attribute(a) }), 'order')
    } else {
      this.attributes = props.attributes
    }
  }

  fullName() {
    return `${this.familyName} ${this.firstName}`
  }
}

export class UserRegister extends User {
  constructor(props = {}) {
    super(props)
    this.password = props.password || ''
    this.password2 = props.password2 || ''
    this.mail2 = props.mail2 || ''

    const attribute = props.attributes
    if (typeof attribute === "string" || attribute instanceof String) {
      this.attributes = _.sortBy(JSON.parse(props.attributes || "[]").map((a) => { return new Attribute(a) }), 'order')
    } else {
      this.attributes = props.attributes
    }
  }

  unMatch({input1, input2}) {
    return input1 !== input2
  }

  unMatchPassword() {
    return this.unMatch({input1: this.password, input2: this.password2})
  }

  invalidPassword() {
    return this.password.length < 8
  }

  unMatchMail() {
    return this.unMatch({input1: this.mail, input2: this.mail2})
  }

  canRegister() {
    return !(_.includes(
      [
        this.mail,
        this.mail2,
        this.password,
        this.password2,
        this.familyName,
        this.firstName,
        this.familyNameKana,
        this.firstNameKana,
      ], '')) && !this.unMatchPassword() && !this.unMatchMail()
  }

  export() {
    return {
      mail: this.mail2,
      password: this.password,
      familyName: this.familyName,
      firstName: this.firstName,
      familyNameKana: this.familyNameKana,
      firstNameKana: this.firstNameKana,
      attributes: JSON.stringify(this.attributes)
    }
  }
}

export class PasswordRegister {
  constructor(props = {}) {
    this.password = props.password || ''
    this.password2 = props.password2 || ''
  }

  unMatch({input1, input2}) {
    return input1 !== input2
  }

  unMatchPassword() {
    return this.unMatch({input1: this.password, input2: this.password2})
  }

  invalidPassword() {
    return this.password.length < 8
  }

  canRegister() {
    return !(_.includes(
      [
        this.password,
        this.password2,
      ], '')) && !this.unMatchPassword()
  }
}
